__webpack_require__.p = "/parkison-portfolio-react/";